import React from 'react';

const MoneyBagIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.33073 2H9.66406C9.92928 2 10.1836 2.10536 10.3712 2.29289C10.5587 2.48043 10.6641 2.73478 10.6641 3C10.6641 3.61884 10.4182 4.21233 9.98064 4.64992C9.54306 5.0875 8.94957 5.33333 8.33073 5.33333H7.66406C7.04522 5.33333 6.45173 5.0875 6.01415 4.64992C5.57656 4.21233 5.33073 3.61884 5.33073 3C5.33073 2.73478 5.43609 2.48043 5.62362 2.29289C5.81116 2.10536 6.06551 2 6.33073 2Z",
      stroke: "#185A67",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.66406 11.3333V10.6667C2.66406 9.25218 3.22597 7.89562 4.22616 6.89543C5.22635 5.89524 6.58291 5.33333 7.9974 5.33333C9.41188 5.33333 10.7684 5.89524 11.7686 6.89543C12.7688 7.89562 13.3307 9.25218 13.3307 10.6667V11.3333C13.3307 12.0406 13.0498 12.7189 12.5497 13.219C12.0496 13.719 11.3713 14 10.6641 14H5.33073C4.62349 14 3.94521 13.719 3.44511 13.219C2.94501 12.7189 2.66406 12.0406 2.66406 11.3333Z",
      stroke: "#185A67",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
MoneyBagIcon.displayName = "Icons.MoneyBagIcon";

export { MoneyBagIcon };
//# sourceMappingURL=MoneyBagIcon.js.map
